import type { PageRequest } from '../Types/Pages.types';

export const pagesQueryKeys = {
  all: ['pages'] as const,
  lists: () => [...pagesQueryKeys.all, 'list'] as const,
  list: (params: PageRequest) => [...pagesQueryKeys.lists(), params] as const,
  details: () => [...pagesQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...pagesQueryKeys.details(), id] as const,
};
